const industries = [
    {
    slug: "manufacturing",
    icon: "",
    title: "Manufacturing",
    description: "Optimize production schedules and supplier coordination with real-time visibility across your manufacturing network.",
    benefits: ["Reduce production delays by 40%", "Improve supplier on-time delivery", "Minimize inventory holding costs", "Predict component shortages early"],
    stats: {
        metric: "40%",
        label: "Reduction in delays"
    },
    solutions: [
    {
        name: "Demand Forecasting",
        slug: "demand-forecasting"
    },
     {
        name: "MIST",
        slug: "inventory-intelligence"
    },
     {
        name: "Order Planning",
        slug: "order-planning"
    },
     {
        name: "WMS",
        slug: "warehouse-management"
    },
     {
        name: "EDIFAI",
        slug: "edifai"
    },
     {
        name: "FairMiles",
        slug: "fairmiles"
    }
]
}, 
{
    slug: "pharmaceuticals",
    icon: "",
    title: "Pharmaceuticals & Healthcare",
    description: "Ensure compliance and cold chain integrity with end-to-end visibility for sensitive medical products.",
    benefits: ["Maintain FDA/GxP compliance", "Real-time temperature monitoring", "Track expiration dates automatically", "Serialization and traceability"],
    stats: {
        metric: "99.9%",
        label: "Compliance rate"
    },
    solutions: [{
        name: "MIST",
        slug: "inventory-intelligence"
    }, {
        name: "Order Planning",
        slug: "order-planning"
    }, {
        name: "WMS",
        slug: "warehouse-management"
    }, {
        name: "Compliance",
        slug: "document-compliance"
    }, {
        name: "Freight Forwarding",
        slug: "freight-forwarding"
    }, {
        name: "Demand Forecasting",
        slug: "demand-forecasting"
    }]
},
 {
    slug: "retail",
    icon: "",
    title: "Retail & E-Commerce",
    description: "Meet customer expectations with accurate delivery promises and seamless omnichannel fulfillment.",
    benefits: ["Accurate ETAs for customers", "Reduce stockouts by 60%", "Optimize last-mile delivery", "Unified inventory visibility"],
    stats: {
        metric: "60%",
        label: "Fewer stockouts"
    },
    solutions: [{
        name: "Demand Forecasting",
        slug: "demand-forecasting"
    }, {
        name: "MIST",
        slug: "inventory-intelligence"
    }, {
        name: "Dispatch Management",
        slug: "dispatch-management"
    }, {
        name: "Lite TMS",
        slug: "lite-tms"
    }, {
        name: "WMS",
        slug: "warehouse-management"
    }, {
        name: "FairMiles",
        slug: "fairmiles"
    }]
}, {
    slug: "automotive",
    icon: "",
    title: "Automotive",
    description: "Coordinate complex multi-tier supply chains and just-in-time manufacturing with precision.",
    benefits: ["JIT delivery optimization", "Multi-tier supplier visibility", "Parts shortage prediction", "Quality tracking end-to-end"],
    stats: {
        metric: "35%",
        label: "Inventory reduction"
    },
    solutions: [{
        name: "Order Planning",
        slug: "order-planning"
    }, {
        name: "EDIFAI",
        slug: "edifai"
    }, {
        name: "WMS",
        slug: "warehouse-management"
    }, {
        name: "Freight Forwarding",
        slug: "freight-forwarding"
    }, {
        name: "PO Tracker",
        slug: "po-pl-tracker"
    }, {
        name: "FairMiles",
        slug: "fairmiles"
    }]
}, {
    slug: "technology",
    icon: "",
    title: "Technology & Electronics",
    description: "Navigate component shortages and global supply complexity with AI-native insights.",
    benefits: ["Component shortage alerts", "Lead time prediction", "Multi-source supplier management", "Demand-supply matching"],
    stats: {
        metric: "3x",
        label: "Faster response"
    },
    solutions: [{
        name: "Demand Forecasting",
        slug: "demand-forecasting"
    }, {
        name: "MIST",
        slug: "inventory-intelligence"
    }, {
        name: "Order Planning",
        slug: "order-planning"
    }, {
        name: "Freight Forwarding",
        slug: "freight-forwarding"
    }, {
        name: "WMS",
        slug: "warehouse-management"
    }, {
        name: "FairMiles",
        slug: "fairmiles"
    }]
}, {
    slug: "sustainability",
    icon: "",
    title: "Food & Agriculture",
    description: "Track farm-to-table supply chains with freshness monitoring and sustainability reporting.",
    benefits: ["Freshness and quality tracking", "Sustainability certifications", "Recall management", "Carbon footprint visibility"],
    stats: {
        metric: "50%",
        label: "Less waste"
    },
    solutions: [{
        name: "IQUA",
        slug: "iqua"
    }, {
        name: "Demand Forecasting",
        slug: "demand-forecasting"
    }, {
        name: "MIST",
        slug: "inventory-intelligence"
    }, {
        name: "Dispatch Management",
        slug: "dispatch-management"
    }, {
        name: "WMS",
        slug: "warehouse-management"
    }, {
        name: "FairMiles",
        slug: "fairmiles"
    }]
}]

export default industries;